import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";

const DynamicPage = lazy(() => import("@/pages/dynamic/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/:slug/",
    children: [
      {
        index: true,
        element: <DynamicPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;